/**
 * wilout/issues#451 — Helpers d'unicité de l'identifiant d'un accès (Validator).
 */

export function nextFreeIdentifiant(existing: string[]): string {
  return firstFree('Accès', existing, 1);
}

export function deriveIdentifiant(source: string, existing: string[]): string {
  const base = source.replace(/\d+$/, '');
  return firstFree(base, existing, base === source ? 2 : 1);
}

export function identifiantEnConflit(
  identifiant: string,
  acces: Array<{ _id?: string; identifiant: string }>,
  currentId?: string,
): boolean {
  return acces.some(a => a.identifiant === identifiant && a._id !== currentId);
}

function firstFree(base: string, existing: string[], from: number): string {
  const taken = new Set(existing);
  for (let n = from; ; n++) {
    const candidate = base + n;
    if (!taken.has(candidate)) {
      return candidate;
    }
  }
}
